module.exports = __webpack_public_path__ + "static/img/samajuri (11).fba85d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (11).jpg
// module id = /mIN
// module chunks = 0